var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var iconContainer = {
    color: "".concat('#42505C'),
    left: 13,
    position: 'absolute',
    top: 12,
    zIndex: 1,
};
export var iconContainerDisabled = __assign(__assign({}, iconContainer), { '.pcty-icon': {
        color: "".concat('#8E9AA3', " !important"),
    } });
export var iconPadding = {
    paddingLeft: '40px !important',
};
export var clearContainer = {
    position: 'absolute',
    top: 1,
    right: 1,
    zIndex: 1,
};
export var clearContainerFocus = {
    position: 'absolute',
    top: 2,
    right: 2,
    zIndex: 1,
};
export var clearPadding = {
    paddingRight: '32px !important',
};
export var readOnly = {
    backgroundColor: 'transparent',
    borderWidth: 0,
    color: '#000000',
    cursor: 'default',
    padding: "".concat(8, "px 0"),
    opacity: 1,
    lineHeight: 1,
};
export var inputContainer = {
    position: 'relative',
    height: 40,
    width: '100%',
};
export var autocomplete = {
    background: '#ffffff',
    border: "1px solid #dadada",
    borderRadius: '8',
    boxShadow: '0px 4px 18px rgba(166, 176, 186, 0.4)',
    boxSizing: 'border-box',
    color: '#000000',
    fontSize: 16,
    left: 0,
    lineHeight: '24px',
    minWidth: 150,
    padding: 8,
    position: 'absolute',
    textAlign: 'left',
    textDecoration: 'none',
    top: 36,
    verticalAlign: 'middle',
    width: '100%',
    zIndex: 1000,
};
export var autocompleteItem = {
    background: 'none',
    border: 'none',
    borderRadius: 8,
    boxSizing: 'border-box',
    color: "".concat('#000000', " !important"),
    fontWeight: 600,
    cursor: 'pointer',
    display: 'inline-block',
    height: 40,
    lineHeight: 'unset',
    overflow: 'hidden',
    padding: "".concat(8, "px ").concat('12', "px"),
    textAlign: 'left',
    textDecoration: 'none',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    width: '100%',
    ':active': {
        background: '#4b5863',
    },
    ':hover': {
        background: '#e1e5e9',
    },
    '[class*="icon"]': {
        display: 'inline-block',
        marginRight: 12,
        verticalAlign: 'middle',
    },
};
export var autocompleteItemFocus = {
    background: '#e1e6eb',
};
export var autocompletePreview = {
    background: '#e1e6eb',
    borderRadius: 5,
    color: '#000000',
    fontSize: 16,
    left: 4,
    lineHeight: 32 + 'px',
    overflow: 'ellipsis',
    paddingLeft: 9,
    position: 'absolute',
    top: 4,
    width: 'calc(100% - 8px)',
};
export var autocompletePreviewIconPadding = {
    paddingLeft: '30px !important',
    paddingRight: '32px !important',
};
export var clearButtonStyles = {
    borderRadius: '0 8px 8px 0 !important',
    border: '0 !important',
    color: "".concat('#42505C', " !important"),
    height: 38,
    width: 32,
    ':active': {
        '--box-shadow-color': 'none',
        boxShadow: 'none',
        backgroundColor: "#b7c0c9 !important",
    },
    ':disabled': {
        background: 'white',
        color: "".concat('#8E9AA3', " !important"),
    },
    ':focus, :focus-visible': {
        '--box-shadow-color': 'none',
        boxShadow: 'none',
        outline: "2px solid #75828c",
    },
    ':hover': {
        backgroundColor: '#e1e5e9',
    },
};
export var iconColor04 = '#323E48';
